<div class="panel-header-container" [formGroup]="technologyFeeFormGroup">
        <div class="panel-header-row">
            <table class="full-width" >
                <tr class="custom-table-row">
                    <td class="no-child-table-definition">{{ 'TECHNOLOGY_FEE' | translate}}</td>
                    <td class="estimate-table-column width-110">
                        {{ technologyFeeFormGroup.controls.cost.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-70"></td>
                    <td class="estimate-table-column width-70">
                        {{technologyFeeFormGroup.controls.tdcPercentage.value | decimalPrecision }}%
                    </td>
                    <td class="estimate-table-column width-70">
                        <ng-container *ngIf="this.isMarkUpSelected; else technologyFeeGrossMarginPercentage">
                            <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-70">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.technologyFeeConfig" inputmode="decimal"
                                    formControlName="markUpPercentage" 
                                    class="mat-white-input" 
                                />
                            </mat-form-field>
                        </ng-container>
                        <ng-template #technologyFeeGrossMarginPercentage>
                            <mat-form-field class="no-padding-input" appearance="outline" class="mat-input-alignment width-70"
                                [class.collab-sapsub-disabled]="isCollaborativeNotEdit">
                                <input matInput [appNumericMask]="solEstimateTableCommonFunctionsService.technologyFeeConfig" inputmode="decimal"
                                    formControlName="grossMarginPercentage" 
                                    class="mat-white-input" 
                                />
                            </mat-form-field>
                        </ng-template>
                    </td>
                    <td class="estimate-table-column width-210 padding-gm">
                        {{ technologyFeeFormGroup.controls.grossMargin.value | multilingualCurrency }}
                    </td>
                    <td class="estimate-table-column width-110">
                        {{ technologyFeeFormGroup.controls.sellPrice.value | multilingualCurrency }}
                    </td>
                </tr>
            </table>
        </div>
    </div>